import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AnnotationStorageServiceService {

    constructor() {
    }


    handleColorSets(ev, key, type = 'ink', borderMode = 'inkColorSettings') {
        let action = ev.target.name || 'set-none';
        let color: number;
        let bgColor: string;
        let borderStyle = 0;
        let noColor = false;
        switch (action) {
            case 'set-black':
                color = 4278190080;
                break;
            case 'set-white':
                color = 16777215;
                break;
            case 'set-red':
                color = 4294901760;
                break;
            case 'set-blue':
                color = 4278201343;
                break;
            case 'set-green':
                color = 65329;
                break;
            case 'set-yellow':
                color = 4294965504;
                break;
            case 'set-none':
                color = 0;
                borderStyle = 6;
                noColor = true;
                break;
            default:
                let config: any = JSON.parse(localStorage.getItem(key + '_' + type)!);
                color = parseInt(config[action].replace('#', '0x'), 16);
        }

        bgColor = this.intToHexColor(color);
        this.setColor(color, type, borderMode, borderStyle);
        document.getElementsByName(borderMode + 'Button').forEach(e => {
            if (e.dataset['type'] == type) {
                if (borderMode == 'borderColorSettings') {
                    e.style.borderColor = bgColor;
                } else {
                    e.style.background = bgColor;
                    e.style.borderColor = '#000000';
                    if (noColor) {
                        e.classList.add('none');
                    } else {
                        e.classList.remove('none');
                    }
                }
            }
        });
    }

    intToHexColor(n: number): string {
        let hexColor = '#000000';
        if (n) {
            let hex: string = n.toString(16);

            hex = hex.padStart(6, '0');
            hex = hex.substring(hex.length - 6, hex.length);

            hexColor = '#' + hex;
        }
        return hexColor;
    }

    getConfig() {
        let config = this.getSubConfig('ink');
        config = this.getSubConfig('highlight');
        config = this.getSubConfig('highlightArea');
        config = this.getSubConfig('square');
        config = this.getSubConfig('polygon');
        config = this.getSubConfig('circle');
        config = this.getSubConfig('polygonPolygonCloud');
        config = this.getSubConfig('polyline');
        config = this.getSubConfig('lineLineArrow');
        config = this.getSubConfig('squiggly');
        config = this.getSubConfig('underline');
        config = this.getSubConfig('strikeout');
        config = this.getSubConfig('freetextFreeTextCallout');
        config = this.getSubConfig('freetextFreeTextTextbox');
        config = this.getSubConfig('freetextFreeTextTypewriter');
        config = this.getSubConfig('lineLineDimension');
        config = this.getSubConfig('polygonPolygonDimension');
        config = this.getSubConfig('circleCircleDimension');
        config = this.getSubConfig('polylinePolyLineDimension');
        config = this.getSubConfig('text');
        return config;
    }

    getSubConfig(type) {
        let config: any = localStorage.getItem('pdf-editor-config');
        if (config) {
            config = JSON.parse(config);
        } else {
            config = this.createDefaultConfig(type, {});
        }

        if (!config[type]) {
            config = this.createDefaultConfig(type, config);
        }

        localStorage.setItem('pdf-editor-config', JSON.stringify(config));
        return config;
    }

    createDefaultConfig(type, config) {
        config[type] = {
            defaultAppearance: {
                font: {
                    name: 'Roboto',
                    baseName: 'Roboto',
                    styles: 32,
                },
                textColor: 4278190080,
                textSize: 12,
            },
            color: 4278190080,
            fillColor: 4278190080,
            borderInfo: {
                width: 1,
                style: 0,
                dashes: [],
            },
            opacity: 1.0,
        };
        return config;
    }

    setColor(color, type = 'ink', borderMode = 'inkColorSettings', borderStyle = 0) {
        let config = this.getConfig();

        switch (borderMode) {
            case 'borderColorSettings':
                this.setBorderColorsByType(config, color, type, borderStyle);
                break;
            case 'backgroundColorSettings':
                this.setBackgroundColorsByType(config, color, type, borderStyle);
                break;
            case 'inkColorSettings':
            default:
                config['freetextFreeTextCallout']['defaultAppearance']['textColor'] = color;
                config['freetextFreeTextTextbox']['defaultAppearance']['textColor'] = color;
                config['freetextFreeTextTypewriter']['defaultAppearance']['textColor'] = color;
                config['text']['color'] = color;
                break;
        }

        config['highlight']['opacity'] = 0.5;
        config['highlightArea']['opacity'] = 0.5;
        localStorage.setItem('pdf-editor-config', JSON.stringify(config));
    }


    setBackgroundColorsByType(config, color, type, borderStyle) {
        switch (type) {
            case 'ink':
                config['ink']['color'] = color;
                break;
            case 'forms':
                config['square']['fillColor'] = color;
                config['circle']['fillColor'] = color;
                config['polygonPolygonCloud']['fillColor'] = color;
                config['polygon']['fillColor'] = color;
                config['lineLineDimension']['color'] = color;
                config['polygonPolygonDimension']['color'] = color;
                config['circleCircleDimension']['color'] = color;
                config['polylinePolyLineDimension']['color'] = color;
                break;
            case 'marker':
                config['highlight']['color'] = color;
                config['highlightArea']['color'] = color;
                config['squiggly']['color'] = color;
                config['underline']['color'] = color;
                config['strikeout']['color'] = color;
                break;
            case 'text':
            default:
                config['freetextFreeTextCallout']['fillColor'] = color;
                config['freetextFreeTextTextbox']['fillColor'] = color;
                break;
        }
    }

    setBorderColorsByType(config, color, type, borderStyle) {
        switch (type) {
            case 'forms':
                config['square']['color'] = color;
                config['circle']['color'] = color;
                config['polygonPolygonCloud']['color'] = color;
                config['polygon']['color'] = color;
                config['square']['borderInfo']['style'] = borderStyle;
                config['circle']['borderInfo']['style'] = borderStyle;
                config['polygonPolygonCloud']['borderInfo']['style'] = borderStyle;
                config['polygon']['borderInfo']['style'] = borderStyle;
                config['polyline']['color'] = color;
                config['lineLineArrow']['color'] = color;
                break;
            case 'text':
            default:
                config['freetextFreeTextCallout']['color'] = color;
                config['freetextFreeTextTextbox']['color'] = color;
                config['freetextFreeTextCallout']['borderInfo']['style'] = borderStyle;
                config['freetextFreeTextTextbox']['borderInfo']['style'] = borderStyle;
                break;
        }
    }

    setTextSize(value: number) {
        const config = this.getConfig();
        config['freetextFreeTextCallout']['defaultAppearance']['textSize'] = value;
        config['freetextFreeTextTextbox']['defaultAppearance']['textSize'] = value;
        config['freetextFreeTextTypewriter']['defaultAppearance']['textSize'] = value;

        localStorage.setItem('pdf-editor-config', JSON.stringify(config));
    }

}
